//销售报表--营业占比分析--按门店
export let storeAnalyseEcharts = {
    id: "storeAnalyseEcharts",
    charsOption: {
      title: {
        top:5,
        text: '占比统计（营业额） -门店',
        left:'center',
        textStyle: {color: "#333", fontSize: "18", fontWeight: "400"},
      },
      tooltip: {
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 80,
        data: []
      },
      color:['#5c6ec8', '#9acd70','#628bf8','#e06567',"#f2c951","#bfc5d2",'#83c0df','#54a36f','#ee8450','#627291'],
      toolbox: {
        left:3,
        top:0,
        orient: 'vertical',
        itemSize: 16,
        show: true,
        optionToContent: function (opt) {
          let series = opt.series;
          let title = opt.title;
          let table = '<h3 style="text-align:center;padding:10px 0;">' + title[0].text + '</h3>'
            + '<table border="1" style="width:100%;text-align:center";border-collapse:collapse;><tbody><tr style="height:40px;">'
            + '<td style="background:#efefef;">序号</td>'
            + '<td style="background:#efefef;">门店</td>'
            + '<td style="background:#efefef;">销售单数</td>'
            + '<td style="background:#efefef;">商品数量</td>'
            + '<td style="background:#efefef;">商品原价</td>'
            + '<td style="background:#efefef;">销售总额</td>'
            + '<td style="background:#efefef;">利润</td>'
            + '<td style="background:#efefef;">营业占比</td>'
            + '</tr>';
            for(var i=0;i<series[0].data.length;i++){
                table += '<tr style="height:40px;">'
                + '<td>' + `${i+1}` + '</td>'
                + '<td>' + series[0].data[i].name + '</td>'
                + '<td>' + series[0].data[i].orderNum + '</td>'
                + '<td>' + series[0].data[i].goodsNum + '</td>'
                + '<td>' + series[0].data[i].retailPrice + '</td>'
                + '<td>' + series[0].data[i].value + '</td>'
                + '<td>' + series[0].data[i].profit + '</td>'
                + '<td>' + series[0].data[i].businessRate + '</td>'
                + '<tr>';
            }
            table += '</tbody></table>';
            return table;
        },
        feature: {
          mark: {show: true},
          dataView: {show: true, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
          magicType: {show: true, type: ['pie']},
          restore: {show: true},
          saveAsImage: {show: true}
        }
      },
      series: [
        {
          name: '来源',
          type: 'pie',
          radius: '70%',
          center: ['50%', '63%'],
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
          }
        }
      ]
    }
  };
  //销售报表--营业占比分析--按商品分类
  export let categoryAnalyseEcharts = {
    id: "categoryAnalyseEcharts",
    charsOption: {
      title: {
        text: '占比统计（营业额） -商品分类 ',
        top:5,
        left: 'center',
        textStyle: {color: "#333", fontSize: "18", fontWeight: "400"},
      },
      tooltip: {
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 80,
        data: []
      },
      color:['#5c6ec8', '#9acd70','#628bf8','#e06567',"#f2c951","#bfc5d2",'#83c0df','#54a36f','#ee8450','#627291'],
      toolbox: {
        left:3,
        top:0,
        orient: 'vertical',
        itemSize: 16,
        show: true,
        optionToContent: function (opt) {
          let series = opt.series;
          let title = opt.title;
          let table = '<h3 style="text-align:center;padding:10px 0;">' + title[0].text + '</h3>'
            + '<table border="1" style="width:100%;text-align:center";border-collapse:collapse;><tbody><tr style="height:40px;">'
            + '<td style="background:#efefef;">序号</td>'
            + '<td style="background:#efefef;">商品分类</td>'
            + '<td style="background:#efefef;">商品数量</td>'
            + '<td style="background:#efefef;">商品原价</td>'
            + '<td style="background:#efefef;">销售额</td>'
            + '<td style="background:#efefef;">销售成本</td>'
            + '<td style="background:#efefef;">营业占比</td>'
            + '<td style="background:#efefef;">利润</td>'
            + '<td style="background:#efefef;">利润率</td>'
            + '</tr>';
            for(var i=0;i<series[0].data.length;i++){
                table += '<tr style="height:40px;">'
                + '<td>' + `${i+1}` + '</td>'
                + '<td>' + series[0].data[i].name + '</td>'
                + '<td>' + series[0].data[i].goodsNum + '</td>'
                + '<td>' + series[0].data[i].retailPrice + '</td>'
                + '<td>' + series[0].data[i].value + '</td>'
                + '<td>' + series[0].data[i].purchasePrice + '</td>'
                + '<td>' + series[0].data[i].businessRate + '</td>'
                + '<td>' + series[0].data[i].profit + '</td>'
                + '<td>' + series[0].data[i].profitRate + '</td>'
                + '<tr>'
            }
          table += '</tbody></table>';
          return table;
        },
        feature: {
          mark: {show: true},
          dataView: {show: true, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
          magicType: {show: true, type: ['pie']},
          restore: {show: true},
          saveAsImage: {show: true}
        }
      },
      series: [
        {
          name: '来源',
          type: 'pie',
          radius: '70%',
          center: ['50%', '63%'],
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
          }
        }
      ]
    }
  };
//销售报表--营业占比分析--按商品品牌
  export let brandAnalyseEcharts = {
    id: "brandAnalyseEcharts",
    charsOption: {
      title: {
        top:5,
        text: '占比统计（营业额） -商品品牌 ',
        left:'center',
        textStyle: {color: "#333", fontSize: "18", fontWeight: "400"},
      },
      tooltip: {
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 80,
        data: []
      },
      color:['#5c6ec8', '#9acd70','#628bf8','#e06567',"#f2c951","#bfc5d2",'#83c0df','#54a36f','#ee8450','#627291'],
      toolbox: {
        left:3,
        top:0,
        orient: 'vertical',
        itemSize: 16,
        show: true,
        optionToContent: function (opt) {
          let series = opt.series;
          let title = opt.title;
          let table = '<h3 style="text-align:center;padding:10px 0;">' + title[0].text + '</h3>'
            + '<table border="1" style="width:100%;text-align:center";border-collapse:collapse;><tbody><tr style="height:40px;">'
            + '<td style="background:#efefef;">序号</td>'
            + '<td style="background:#efefef;">商品品牌</td>'
            + '<td style="background:#efefef;">商品数量</td>'
            + '<td style="background:#efefef;">商品原价</td>'
            + '<td style="background:#efefef;">销售额</td>'
            + '<td style="background:#efefef;">销售成本</td>'
            + '<td style="background:#efefef;">营业占比</td>'
            + '<td style="background:#efefef;">利润</td>'
            + '<td style="background:#efefef;">利润率</td>'
            + '</tr>';
            for(var i=0;i<series[0].data.length;i++){
                table += '<tr style="height:40px;">'
                + '<td>' + `${i+1}` + '</td>'
                + '<td>' + series[0].data[i].name + '</td>'
                + '<td>' + series[0].data[i].goodsNum + '</td>'
                + '<td>' + series[0].data[i].retailPrice + '</td>'
                + '<td>' + series[0].data[i].value + '</td>'
                + '<td>' + series[0].data[i].purchasePrice + '</td>'
                + '<td>' + series[0].data[i].businessRate + '</td>'
                + '<td>' + series[0].data[i].profit + '</td>'
                + '<td>' + series[0].data[i].profitRate + '</td>'
                + '<tr>'
            }
          table += '</tbody></table>';
          return table;
        },
        feature: {
          mark: {show: true},
          dataView: {show: true, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
          magicType: {show: true, type: ['pie']},
          restore: {show: true},
          saveAsImage: {show: true}
        }
      },
      series: [
        {
          name: '来源',
          type: 'pie',
          radius: '70%',
          center: ['50%', '63%'],
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
          }
        }
      ]
    }
  };
  //销售报表--营业占比分析--按导购员
  export let guideAnalyseEcharts = {
    id: "guideAnalyseEcharts",
    charsOption: {
      title: {
        top:5,
        text: '占比统计（营业额） -导购员 ',
        left:'center',
        textStyle: {color: "#333", fontSize: "18", fontWeight: "400"},
      },
      tooltip: {
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 80,
        data: []
      },
      color:['#5c6ec8', '#9acd70','#628bf8','#e06567',"#f2c951","#bfc5d2",'#83c0df','#54a36f','#ee8450','#627291'],
      toolbox: {
        left:3,
        top:0,
        orient: 'vertical',
        itemSize: 16,
        show: true,
        optionToContent: function (opt) {
          let series = opt.series;
          let title = opt.title;
          let table = '<h3 style="text-align:center;padding:10px 0;">' + title[0].text + '</h3>'
            + '<table border="1" style="width:100%;text-align:center";border-collapse:collapse;><tbody><tr style="height:40px;">'
            + '<td style="background:#efefef;">序号</td>'
            + '<td style="background:#efefef;">导购员</td>'
            + '<td style="background:#efefef;">销售单数</td>'
            + '<td style="background:#efefef;">商品数量</td>'
            + '<td style="background:#efefef;">商品原价</td>'
            + '<td style="background:#efefef;">销售额</td>'
            + '<td style="background:#efefef;">营业占比</td>'
            + '<td style="background:#efefef;">利润</td>'
            + '<td style="background:#efefef;">利润率</td>'
            + '</tr>';
            for(var i=0;i<series[0].data.length;i++){
              table += '<tr style="height:40px;">'
                + '<td>' + `${i+1}` + '</td>'
                + '<td>' + series[0].data[i].name + '</td>'
                + '<td>' + series[0].data[i].orderNum + '</td>'
                + '<td>' + series[0].data[i].goodsNum + '</td>'
                + '<td>' + series[0].data[i].retailPrice + '</td>'
                + '<td>' + series[0].data[i].value + '</td>'
                + '<td>' + series[0].data[i].businessRate + '</td>'
                + '<td>' + series[0].data[i].profit + '</td>'
                + '<td>' + series[0].data[i].profitRate + '</td>'
                + '<tr>'
            }
          table += '</tbody></table>';
          return table;
        },
        feature: {
          mark: {show: true},
          dataView: {show: true, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
          magicType: {show: true, type: ['pie']},
          restore: {show: true},
          saveAsImage: {show: true}
        }
      },
      series: [
        {
          name: '来源',
          type: 'pie',
          radius: '70%',
          center: ['50%', '63%'],
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
          }
        }
      ]
    }
  };
   //销售报表--营业占比分析--按收银员
   export let cashierAnalyseEcharts = {
    id: "cashierAnalyseEcharts",
    charsOption: {
      title: {
        top:5,
        text: '占比统计（营业额） -收银员 ',
        left:'center',
        textStyle: {color: "#333", fontSize: "18", fontWeight: "400"},
      },
      tooltip: {
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 80,
        data: []
      },
      color:['#5c6ec8', '#9acd70','#628bf8','#e06567',"#f2c951","#bfc5d2",'#83c0df','#54a36f','#ee8450','#627291'],
      toolbox: {
        left:3,
        top:0,
        orient: 'vertical',
        itemSize: 16,
        show: true,
        optionToContent: function (opt) {
          let series = opt.series;
          let title = opt.title;
          let table = '<h3 style="text-align:center;padding:10px 0;">' + title[0].text + '</h3>'
            + '<table border="1" style="width:100%;text-align:center";border-collapse:collapse;><tbody><tr style="height:40px;">'
            + '<td style="background:#efefef;">序号</td>'
            + '<td style="background:#efefef;">收银员</td>'
            + '<td style="background:#efefef;">销售单数</td>'
            + '<td style="background:#efefef;">商品数量</td>'
            + '<td style="background:#efefef;">商品原价</td>'
            + '<td style="background:#efefef;">销售额</td>'
            + '<td style="background:#efefef;">营业占比</td>'
            + '<td style="background:#efefef;">利润</td>'
            + '<td style="background:#efefef;">利润率</td>'
            + '</tr>';
            for(var i=0;i<series[0].data.length;i++){
              table += '<tr style="height:40px;">'
                + '<td>' + `${i+1}` + '</td>'
                + '<td>' + series[0].data[i].name + '</td>'
                + '<td>' + series[0].data[i].orderNum + '</td>'
                + '<td>' + series[0].data[i].goodsNum + '</td>'
                + '<td>' + series[0].data[i].retailPrice + '</td>'
                + '<td>' + series[0].data[i].value + '</td>'
                + '<td>' + series[0].data[i].businessRate + '</td>'
                + '<td>' + series[0].data[i].profit + '</td>'
                + '<td>' + series[0].data[i].profitRate + '</td>'
                + '<tr>'
            }
          table += '</tbody></table>';
          return table;
        },
        feature: {
          mark: {show: true},
          dataView: {show: true, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
          magicType: {show: true, type: ['pie']},
          restore: {show: true},
          saveAsImage: {show: true}
        }
      },
      series: [
        {
          name: '来源',
          type: 'pie',
          radius: '70%',
          center: ['50%', '63%'],
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
          }
        }
      ]
    }
  };
   //销售报表--营业占比分析--按支付方式
   export let paymentAnalyseEcharts = {
    id: "paymentAnalyseEcharts",
    charsOption: {
      title: {
        top:5,
        text: '占比统计（营业额） -支付方式 ',
        left:'center',
        textStyle: {color: "#333", fontSize: "18", fontWeight: "400"},
      },
      tooltip: {
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 80,
        data: []
      },
      color:['#5c6ec8', '#9acd70','#628bf8','#e06567',"#f2c951","#bfc5d2",'#83c0df','#54a36f','#ee8450','#627291'],
      toolbox: {
        left:3,
        top:0,
        orient: 'vertical',
        itemSize: 16,
        show: true,
        optionToContent: function (opt) {
          let series = opt.series;
          let title = opt.title;
          let table = '<h3 style="text-align:center;padding:10px 0;">' + title[0].text + '</h3>'
            + '<table border="1" style="width:100%;text-align:center";border-collapse:collapse;><tbody><tr style="height:40px;">'
            + '<td style="background:#efefef;">序号</td>'
            + '<td style="background:#efefef;">支付方式</td>'
            + '<td style="background:#efefef;">销售单数</td>'
            + '<td style="background:#efefef;">商品数量</td>'
            + '<td style="background:#efefef;">商品原价</td>'
            + '<td style="background:#efefef;">销售额</td>'
            + '<td style="background:#efefef;">营业占比</td>'
            + '<td style="background:#efefef;">利润</td>'
            + '<td style="background:#efefef;">利润率</td>'
            + '</tr>';
            for(var i=0;i<series[0].data.length;i++){
              table += '<tr style="height:40px;">'
                + '<td>' + `${i+1}` + '</td>'
                + '<td>' + series[0].data[i].name + '</td>'
                + '<td>' + series[0].data[i].orderNum + '</td>'
                + '<td>' + series[0].data[i].goodsNum + '</td>'
                + '<td>' + series[0].data[i].retailPrice + '</td>'
                + '<td>' + series[0].data[i].value + '</td>'
                + '<td>' + series[0].data[i].businessRate + '</td>'
                + '<td>' + series[0].data[i].profit + '</td>'
                + '<td>' + series[0].data[i].profitRate + '</td>'
                + '<tr>'
            }
          table += '</tbody></table>';
          return table;
        },
        feature: {
          mark: {show: true},
          dataView: {show: true, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
          magicType: {show: true, type: ['pie']},
          restore: {show: true},
          saveAsImage: {show: true}
        }
      },
      series: [
        {
          name: '来源',
          type: 'pie',
          radius: '70%',
          center: ['50%', '63%'],
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
          }
        }
      ]
    }
  };
   //销售报表--营业占比分析--按是否是会员
   export let memberAnalyseEcharts = {
    id: "memberAnalyseEcharts",
    charsOption: {
      title: {
        top:5,
        text: '占比统计（营业额） -是否会员 ',
        left:'center',
        textStyle: {color: "#333", fontSize: "18", fontWeight: "400"},
      },
      tooltip: {
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 80,
        data: []
      },
      color:['#5c6ec8', '#9acd70','#628bf8','#e06567',"#f2c951","#bfc5d2",'#83c0df','#54a36f','#ee8450','#627291'],
      toolbox: {
        left:3,
        top:0,
        orient: 'vertical',
        itemSize: 16,
        show: true,
        optionToContent: function (opt) {
          let series = opt.series;
          let title = opt.title;
          let table = '<h3 style="text-align:center;padding:10px 0;">' + title[0].text + '</h3>'
            + '<table border="1" style="width:100%;text-align:center";border-collapse:collapse;><tbody><tr style="height:40px;">'
            + '<td style="background:#efefef;">序号</td>'
            + '<td style="background:#efefef;">支付方式</td>'
            + '<td style="background:#efefef;">销售单数</td>'
            + '<td style="background:#efefef;">商品数量</td>'
            + '<td style="background:#efefef;">商品原价</td>'
            + '<td style="background:#efefef;">销售额</td>'
            + '<td style="background:#efefef;">营业占比</td>'
            + '<td style="background:#efefef;">利润</td>'
            + '<td style="background:#efefef;">利润率</td>'
            + '</tr>';
            for(var i=0;i<series[0].data.length;i++){
              table += '<tr style="height:40px;">'
                + '<td>' + `${i+1}` + '</td>'
                + '<td>' + series[0].data[i].name + '</td>'
                + '<td>' + series[0].data[i].orderNum + '</td>'
                + '<td>' + series[0].data[i].goodsNum + '</td>'
                + '<td>' + series[0].data[i].retailPrice + '</td>'
                + '<td>' + series[0].data[i].value + '</td>'
                + '<td>' + series[0].data[i].businessRate + '</td>'
                + '<td>' + series[0].data[i].profit + '</td>'
                + '<td>' + series[0].data[i].profitRate + '</td>'
                + '<tr>'
            }
          table += '</tbody></table>';
          return table;
        },
        feature: {
          mark: {show: true},
          dataView: {show: true, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
          magicType: {show: true, type: ['pie']},
          restore: {show: true},
          saveAsImage: {show: true}
        }
      },
      series: [
        {
          name: '来源',
          type: 'pie',
          radius: '70%',
          center: ['50%', '63%'],
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
          }
        }
      ]
    }
  };
   //销售报表--营业占比分析--按供应商
   export let merchantAnalyseEcharts = {
    id: "merchantAnalyseEcharts",
    charsOption: {
      title: {
        top:5,
        text: '占比统计（营业额） -供应商 ',
        left:'center',
        textStyle: {color: "#333", fontSize: "18", fontWeight: "400"},
      },
      tooltip: {
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 80,
        data: []
      },
      color:['#5c6ec8', '#9acd70','#628bf8','#e06567',"#f2c951","#bfc5d2",'#83c0df','#54a36f','#ee8450','#627291'],
      toolbox: {
        left:3,
        top:0,
        orient: 'vertical',
        itemSize: 16,
        show: true,
        optionToContent: function (opt) {
          let series = opt.series;
          let title = opt.title;
          let table = '<h3 style="text-align:center;padding:10px 0;">' + title[0].text + '</h3>'
            + '<table border="1" style="width:100%;text-align:center";border-collapse:collapse;><tbody><tr style="height:40px;">'
            + '<td style="background:#efefef;">序号</td>'
            + '<td style="background:#efefef;">供应商</td>'
            + '<td style="background:#efefef;">商品数量</td>'
            + '<td style="background:#efefef;">商品原价</td>'
            + '<td style="background:#efefef;">销售额</td>'
            + '<td style="background:#efefef;">销售成本</td>'
            + '<td style="background:#efefef;">营业占比</td>'
            + '<td style="background:#efefef;">利润</td>'
            + '<td style="background:#efefef;">利润率</td>'
            + '</tr>';
            for(var i=0;i<series[0].data.length;i++){
              table += '<tr style="height:40px;">'
                + '<td>' + `${i+1}` + '</td>'
                + '<td>' + series[0].data[i].name + '</td>'
                + '<td>' + series[0].data[i].goodsNum + '</td>'
                + '<td>' + series[0].data[i].retailPrice + '</td>'
                + '<td>' + series[0].data[i].value + '</td>'
                + '<td>' + series[0].data[i].purchasePrice + '</td>'
                + '<td>' + series[0].data[i].businessRate + '</td>'
                + '<td>' + series[0].data[i].profit + '</td>'
                + '<td>' + series[0].data[i].profitRate + '</td>'
                + '<tr>'
            }
          table += '</tbody></table>';
          return table;
        },
        feature: {
          mark: {show: true},
          dataView: {show: true, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
          magicType: {show: true, type: ['pie']},
          restore: {show: true},
          saveAsImage: {show: true}
        }
      },
      series: [
        {
          name: '来源',
          type: 'pie',
          radius: '70%',
          center: ['50%', '63%'],
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
          }
        }
      ]
    }
  };
  //销售报表 --商品销售统计 --商品销售趋势分析
  export let goodsSaleTrendEcharts = {
    id: "goodsSaleTrendEcharts",
    charsOption: {
      title: {
        top:0,
        right:0,
        textStyle: {color: "#5ab1ef", fontSize: "20", fontWeight: "400"},
        text: '',
    },
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data: ['销售总额', '销售数量','利润']
    },
    toolbox: {
        top:50,
        right:0,
        orient: 'vertical',
        itemSize: 23,
        show: true,
        feature: {
            dataView: {show: false, readOnly: false},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
        }
    },
    color:['#2ec7c9', '#b6a2de','#5ab1ef'],
    calculable: true,
    xAxis: [
        {
            type: 'category',
            data: []
        }
    ],
    yAxis: [
        {
            type: 'value'
        }
    ],
    series: [
        {
            name: '销售总额',
            type: 'bar',
            data: [],
            markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
            markLine: {
                data: [
                    {type: 'average', name: '平均值'}
                ]
            }
        },
        {
            name: '销售数量',
            type: 'bar',
            data: [],
            markPoint: {
                data: [
                  {type: 'max', name: '最大值'},
                  {type: 'min', name: '最小值'}
                ]
            },
            markLine: {
                data: [
                    {type: 'average', name: '平均值'}
                ]
            }
        },
        {
          name: '利润',
          type: 'bar',
          data: [],
          markPoint: {
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ]
          },
          markLine: {
              data: [
                  {type: 'average', name: '平均值'}
              ]
          }
      }
    ]
    },
  }
  //销售报表-营业趋势分析--销售趋势分析
  export let trendTrendEcharts = {
    id: "trendTrendEcharts",
    charsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          }
        },
        //上方小按钮
        toolbox: {
          itemSize:23,
          show: true,
          feature: {
            mark: {show: true},
            dataView: {show: false, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        calculable: true,
        legend: {
          data: ["销售总额", "销售单数", "商品数量","利润","毛利率","库存占比"],
          itemGap: 5
        },
        color:['#0088dd', '#88cc44','#5856d6','#44bbaa',"#ff9900","#ffcc00"],
        grid: {
          top: '11%',
          left: '0%',
          right: '3%',
          bottom:"3%",
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
          }
        ],
        dataZoom: [
          {
            show: false,
            start: 0,
            end: 100
          },
          {
            type: 'inside',
            start: 94,
            end: 100
          },
          {
            show: false,
            yAxisIndex: 0,
            filterMode: 'empty',
            width:20,
            height: '80%',
            showDataShadow: false,
            left: '93%'
          }
        ],
        series: [
          {
            name: '销售总额',
            type: 'bar',
            barGap: 6,
            barWidth : 30,
            data: [],
            markLine: {
              data: [
                  {type: 'average', name: '平均值'}
              ]
          }
          },
          {
            name: '销售单数',
            type: 'bar',
            barGap: 6,
            barWidth : 30,
            data: [],
            markLine: {
              data: [
                  {type: 'average', name: '平均值'}
              ]
          }
          },
          {
            name: '商品数量',
            type: 'bar',
            barGap: 6,
            barWidth : 30,
            data: [],
            markLine: {
              data: [
                  {type: 'average', name: '平均值'}
              ]
          }
          },
          {
            name: '利润',
            type: 'bar',
            barGap: 6,
            barWidth : 30,
            data: [],
            markLine: {
              data: [
                  {type: 'average', name: '平均值'}
              ]
          }
          },
          {
            name: '毛利率',
            type: 'line',
            barGap: 6,
            data: [],
            markLine: {
              data: [
                  {type: 'average', name: '平均值'}
              ]
          }
          },
          {
            name: '库存占比',
            type: 'line',
            barGap: 6,
            data: [],
            markLine: {
              data: [
                  {type: 'average', name: '平均值'}
              ]
          }
          },
        ]
      }
  };
  //销售报表-营业趋势分析--销售总额分析
    export let totalAnalyseEcharts = {
        id: "totalAnalyseEcharts",
        charsOption: {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  show: true
                }
              }
            },
            //上方小按钮
            toolbox: {
              itemSize: 23,
              show: true,
              feature: {
                mark: {show: true},
                dataView: {show: false, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
                magicType: {show: true, type: ['line', 'bar']},
                restore: {show: true},
                saveAsImage: {show: true}
              }
            },
            calculable: true,
            legend: {
              data: ["销售总额", "销售单数", "平均每单商品数","商品均价"],
              itemGap: 5
            },
            color:['#0088dd', '#88cc44','#44bbaa','#5856d6'],
            grid: {
              top: '12%',
              left: '3%',
              right: '5%',
              bottom:"4%",
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: []
              }
            ],
            yAxis: [
              {
                type: 'value',
                name: '',
                min: 0,
                max: 100,
                interval: 10,
                // axisLabel: {
                //   formatter: '{value} %'
                // }
              }
            ],
            dataZoom: [
              {
                show: false,
                start: 0,
                end: 100
              },
              {
                type: 'inside',
                start: 94,
                end: 100
              },
              {
                show: false,
                yAxisIndex: 0,
                filterMode: 'empty',
                width: 30,
                height: '80%',
                showDataShadow: false,
                left: '93%'
              }
            ],
            series: [
              {
                name: '销售总额',
                type: 'bar',
                barGap: 6,
                data: [],
                barWidth : 20,
                markLine: {
                  data: [
                      {type: 'average', name: '平均值'}
                  ]
              }
              },
              {
                name: '销售单数',
                type: 'bar',
                barGap: 6,
                data: [],
                barWidth : 20,
                markLine: {
                  data: [
                      {type: 'average', name: '平均值'}
                  ]
              }
              },
              {
                name: '平均每单商品数',
                type: 'bar',
                barGap: 6,
                data: [],
                barWidth : 20,
                markLine: {
                  data: [
                      {type: 'average', name: '平均值'}
                  ]
              }
              },
              {
                name: '商品均价',
                type: 'bar',
                barGap: 6,
                data: [],
                barWidth : 20,
                markLine: {
                  data: [
                      {type: 'average', name: '平均值'}
                  ]
              }
              },
            ]
          }
      };
  //销售报表-商城概览--订单交易量趋势图
  export let orderTrendEcharts = {
    id: "orderTrendEcharts",
    charsOption: {
    color:['#e01f54',"#96dee8","#5f58e6"],
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data: ['订单', '会员', '交易额'],
    },
    grid: {
        left: '0%',
        right: '4%',
        bottom: '1%',
        top:"11%",
        containLabel: true
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        splitLine: {
          show: true
        }
    },
    yAxis: {
        type: 'value',
        splitLine: {
          show: true
        }
    },
    series: [
        {
            name: '订单',
            type: 'line',
            stack: '总量',
            data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
            name: '会员',
            type: 'line',
            stack: '总量',
            data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
            name: '交易额',
            type: 'line',
            stack: '总量',
            data: [150, 232, 201, 154, 190, 330, 410]
        },
    ]
  }
  };
  //商品销售统计---营业趋势分析
  export let goodsTrendEcharts = {
    id: "goodsTrendEcharts",
    charsOption: {
    color:['#e01f54',"#96dee8","#5f58e6"],
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data: ['订单', '会员', '交易额'],
    },
    grid: {
        left: '0%',
        right: '4%',
        bottom: '1%',
        top:"11%",
        containLabel: true
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        splitLine: {
          show: true
        }
    },
    yAxis: {
        type: 'value',
        splitLine: {
          show: true
        }
    },
    series: [
        {
            name: '订单',
            type: 'line',
            stack: '总量',
            data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
            name: '会员',
            type: 'line',
            stack: '总量',
            data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
            name: '交易额',
            type: 'line',
            stack: '总量',
            data: [150, 232, 201, 154, 190, 330, 410]
        },
    ]
  }
  };



// WEBPACK FOOTER //
// ./src/page/home/options/saleReportEcharts.js